module.exports = __webpack_public_path__ + "static/media/img1-5.5697a929.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/pepino/biosense/diff/img1-5.png
// module id = 2091
// module chunks = 3